export type NormalizedRuntimeFailure = {
  readonly original: unknown;
  readonly failure: unknown;
  readonly identities: readonly unknown[];
};

export function normalizeRuntimeFailure(error: unknown): NormalizedRuntimeFailure {
  return { original: error, failure: error, identities: [error] };
}
